import axios from "axios";
const CONTROLLER_PATH = "Sms";
class SmsService {

    
    //READ
    getsmsreplyaction(id, urlParameters, requestId) {
        return axios
            .get(CONTROLLER_PATH + "/GetSmsReplyAction" + (id ? "/" + id : ""), {
                params: urlParameters,
                requestId: requestId,
            })
            .then((response) => ({
                data: response.data,
                requestId: response.config.requestId,
            }));
    }

    getsmsunmatchedreplyaction(id, urlParameters, requestId) {
        return axios
            .get(CONTROLLER_PATH + "/GetSmsUnmatchedReplyAction" + (id ? "/" + id : ""), {
                params: urlParameters,
                requestId: requestId,
            })
            .then((response) => ({
                data: response.data,
                requestId: response.config.requestId,
            }));
    }
    
}

export default new SmsService();
